import { render } from "./AdminsList.vue?vue&type=template&id=451d4af5"
import script from "./AdminsList.vue?vue&type=script&lang=js"
export * from "./AdminsList.vue?vue&type=script&lang=js"

import "./AdminsList.vue?vue&type=style&index=0&id=451d4af5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__